module.exports = __webpack_public_path__ + "img/file.6f744bac.png";